import $ from 'jquery';
import plugin from '@core/plugins/lib';
import CartNotification from './cart-notification';

const ELEMENT_SELECTOR = '[data-add-to-cart-notification]';
const PLUGIN_NAME = 'CartNotification';

plugin(PLUGIN_NAME, CartNotification);

$(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/cart-notification/index.js